<template>
  <NavBar />
  <BackgroundImage
    :imageUrl="require('@/assets/login/bg.png')"
    :customStyle="{
      minHeight: '100vh',
    }"
  >
    <div class="container">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="page-title">数智郎中</h1>
      </div>

      <!-- 人气推荐 -->
      <section class="recommend-section">
        <h2 class="section-title">人气推荐</h2>
        <div class="recommend-carousel">
          <a-carousel autoplay :dots="true">
            <div v-for="doctor in recommendDoctors" :key="doctor.id" class="carousel-item">
              <div class="recommend-card" @click="goToDoctorDetail(doctor.id)">
                <div class="recommend-badge">
                  <img src="@/assets/images/ai-badge.svg" alt="AI分身" class="badge-icon" />
                  <span>AI分身</span>
                </div>
                <div class="recommend-content">
                  <div class="doctor-info">
                    <h3 class="doctor-name">{{ doctor.name }}</h3>
                    <p class="doctor-title">{{ doctor.title }}</p>
                    <p class="doctor-specialty">擅长治疗：{{ doctor.specialty }}</p>
                  </div>
                  <div class="doctor-avatar-wrapper">
                    <img :src="doctor.avatar" :alt="doctor.name" class="doctor-avatar" />
                  </div>
                </div>
                <div class="recommend-footer">
                  <a-button type="primary" size="large" class="consult-btn">
                    <template #icon>
                      <MessageOutlined />
                    </template>
                    {{ doctor.question }}
                  </a-button>
                </div>
              </div>
            </div>
          </a-carousel>
        </div>
      </section>

      <!-- 更多热门 -->
      <section class="hot-section">
        <h2 class="section-title">更多热门</h2>
        <a-spin :spinning="loading" tip="加载中...">
          <a-row :gutter="[24, 24]">
            <a-col 
              v-for="doctor in hotDoctors" 
              :key="doctor.id"
              :xs="24" 
              :sm="12" 
              :md="12" 
              :lg="6" 
              :xl="6"
            >
              <div class="doctor-card" @click="goToDoctorDetail(doctor.id)">
                <div class="card-header">
                  <div class="ai-badge-small">
                    <img src="@/assets/images/ai-badge.svg" alt="AI" class="badge-icon-small" />
                    <span>{{ doctor.type_str }}</span>
                  </div>
                  <img :src="doctor.avatar" :alt="doctor.name" class="card-avatar" />
                </div>
                <div class="card-body">
                  <div class="name-tag-row">
                    <h3 class="card-name">{{ doctor.name }}</h3>
                  </div>
                  <div v-if="doctor.tag && doctor.tag.length > 0" class="tags-wrapper">
                    <span 
                      v-for="(tag, index) in doctor.tag" 
                      :key="index" 
                      class="card-tag"
                    >
                      {{ tag.name }}
                    </span>
                  </div>
                  <p class="card-title">{{ doctor.title }}</p>
                  <p class="card-specialty">擅长治疗：{{ doctor.specialty }}</p>
                </div>
              </div>
            </a-col>
          </a-row>
          
          <!-- 空状态 -->
          <a-empty v-if="!loading && hotDoctors.length === 0" description="暂无医生数据" />
        </a-spin>
      </section>
    </div>
  </BackgroundImage>
</template>

<script>
import BackgroundImage from "@/components/BackgroundImage.vue";
import NavBar from "@/components/NavBar.vue";
import { MessageOutlined } from "@ant-design/icons-vue";
import api from "@/api";

export default {
  name: "DoctorListPage",
  components: {
    BackgroundImage,
    NavBar,
    MessageOutlined,
  },
  data() {
    return {
      loading: false,
      recommendDoctors: [],
      hotDoctors: [],
    };
  },
  methods: {
    goToDoctorDetail(doctorId) {
      const tmpDoctor = this.hotDoctors.find(doc => doc.id === doctorId)
      if (tmpDoctor) {
        if (tmpDoctor.type == 1) {
          this.$router.push(`/xiaofu?id=${doctorId}`);
          return;
        }
        if (tmpDoctor.type == 2) {
          this.$router.push(`/pill?id=${doctorId}`);
          return;
        }
      }

      this.$router.push(`/ai-doctor?id=${doctorId}`);
    },
    // 获取列表
    async getList() {
      this.loading = true;
      try {
        const response = await api.doctor.getList();
        // response.data 内容
        // [{
        //  bio: "" // 医生简介
        //  doctor_id: 1,
        //  expertise: "" // 专业特长
        //  more: { thumbnail: "" } // 头像
        //  name: "" // 医生姓名
        //  tag: "" // 标签
        //  tag_id: "" // 标签ID
        // }]
        if (Array.isArray(response.data) && response.data.length > 0) {
          // 转换数据格式
          const doctors = response.data.map(item => ({
            id: item.doctor_id,
            name: item.name || '',
            avatar: item.more?.thumbnail || 'https://qihuang.oss-cn-qingdao.aliyuncs.com/images/doctor/default.png',
            title: item.bio || '',
            specialty: item.expertise || '',
            tag: item.tag || '',
            type: item.type || 1,
            type_str: item.type_str || 'AI',
            question: `${item.name}医生的专业特长是什么？`,
          }));
          
          // 设置热门医生列表
          this.hotDoctors = doctors;
          
          // 设置推荐医生（取第一个type=3\没有再取[0]）
          let tmpDoctor = doctors.find(doc => doc.type === 3);

          if (tmpDoctor) {
            this.recommendDoctors = [tmpDoctor];
          } else if (doctors.length > 0) {
            this.recommendDoctors = [doctors[0]];
          }
        }
      } catch (error) {
        console.error('获取医生列表失败:', error);
        this.$message.error('获取医生列表失败');
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 80px 20px 60px;
  max-width: 1320px;
  margin: 0 auto;
  min-height: 100vh;
  
  @media (min-width: 992px) {
    padding-left: 0;
    padding-right: 0;
  }
}

.page-header {
  text-align: center;
  margin-bottom: 48px;
}

.page-title {
  font-size: 40px;
  font-weight: 700;
  background: linear-gradient(135deg, #1041B5 0%, #5E7BF3 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
  letter-spacing: 2px;
  
  @media (max-width: 768px) {
    font-size: 32px;
  }
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #1041B5;
  margin-bottom: 24px;
  padding-left: 16px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 5px;
    height: 28px;
    background: linear-gradient(180deg, #5E7BF3 0%, #1041B5 100%);
    border-radius: 3px;
    box-shadow: 0 2px 8px rgba(94, 123, 243, 0.3);
  }
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
}

// 人气推荐区域
.recommend-section {
  margin-bottom: 60px;
  
  @media (min-width: 992px) {
    padding: 0 12px;
  }
}

.recommend-carousel {
  :deep(.ant-carousel) {
    .slick-dots {
      bottom: -40px;
      
      li {
        button {
          background: rgba(94, 123, 243, 0.3);
          border-radius: 4px;
          height: 4px;
        }
        
        &.slick-active button {
          background: #5E7BF3;
          width: 32px;
        }
      }
    }
  }
}

.carousel-item {
  padding: 0 10px;
}

.recommend-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  border: 1.5px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(16, 65, 181, 0.15);
  padding: 32px;
  cursor: pointer;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(94, 123, 243, 0.1) 0%, transparent 70%);
    transition: all 0.6s ease;
    opacity: 0;
  }
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 16px 48px rgba(16, 65, 181, 0.25);
    border-color: rgba(94, 123, 243, 0.5);
    
    &::before {
      opacity: 1;
      top: -10%;
      right: -10%;
    }
    
    .doctor-avatar {
      transform: scale(1.1) rotate(3deg);
    }
  }
  
  @media (max-width: 768px) {
    padding: 24px;
  }
}

.recommend-badge {
  position: absolute;
  top: 24px;
  right: 24px;
  background: linear-gradient(135deg, rgba(94, 123, 243, 0.9) 0%, rgba(16, 65, 181, 0.9) 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(94, 123, 243, 0.3);
  z-index: 2;
  
  .badge-icon {
    width: 18px;
    height: 18px;
    filter: brightness(0) invert(1);
  }
  
  @media (max-width: 768px) {
    top: 16px;
    right: 16px;
    font-size: 12px;
    padding: 6px 12px;
  }
}

.recommend-content {
  display: flex;
  gap: 32px;
  align-items: flex-start;
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 20px;
  }
}

.doctor-info {
  flex: 1;
}

.doctor-name {
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #1041B5 0%, #5E7BF3 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 12px;
  letter-spacing: 1px;
  
  @media (max-width: 768px) {
    font-size: 26px;
  }
}

.doctor-title {
  font-size: 15px;
  color: #666;
  margin-bottom: 16px;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
}

.doctor-specialty {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  font-weight: 500;
  
  @media (max-width: 768px) {
    font-size: 15px;
  }
}

.doctor-avatar-wrapper {
  flex-shrink: 0;
}

.doctor-avatar {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  object-fit: cover;
  border: 5px solid rgba(94, 123, 243, 0.2);
  box-shadow: 0 8px 24px rgba(94, 123, 243, 0.25);
  transition: all 0.4s ease;
  
  @media (max-width: 768px) {
    width: 140px;
    height: 140px;
  }
}

.recommend-footer {
  display: flex;
  justify-content: center;
}

.consult-btn {
  height: 56px;
  padding: 0 40px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 28px;
  background: linear-gradient(135deg, #5E7BF3 0%, #1041B5 100%);
  border: none;
  box-shadow: 0 6px 20px rgba(94, 123, 243, 0.3);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(94, 123, 243, 0.4);
  }
  
  :deep(.anticon) {
    font-size: 18px;
  }
  
  @media (max-width: 768px) {
    height: 48px;
    padding: 0 32px;
    font-size: 15px;
  }
}

// 更多热门区域
.hot-section {
  margin-bottom: 40px;
  
  @media (min-width: 992px) {
    padding: 0 12px;
  }
}

.doctor-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1.5px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 20px rgba(16, 65, 181, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 36px rgba(16, 65, 181, 0.2);
    border-color: rgba(94, 123, 243, 0.5);
    
    .card-avatar {
      transform: scale(1.1);
    }
  }
}

.card-header {
  position: relative;
  background: linear-gradient(135deg, rgba(94, 123, 243, 0.08) 0%, rgba(16, 65, 181, 0.05) 100%);
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  
  @media (max-width: 768px) {
    min-height: 180px;
    padding: 20px;
  }
}

.ai-badge-small {
  position: absolute;
  top: 16px;
  left: 16px;
  background: linear-gradient(135deg, rgba(94, 123, 243, 0.9) 0%, rgba(16, 65, 181, 0.9) 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 3px 10px rgba(94, 123, 243, 0.3);
  
  .badge-icon-small {
    width: 14px;
    height: 14px;
    filter: brightness(0) invert(1);
  }
}

.card-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 6px 20px rgba(94, 123, 243, 0.2);
  transition: all 0.4s ease;
  
  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
  }
}

.card-body {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.name-tag-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.card-name {
  font-size: 20px;
  font-weight: 700;
  color: #1041B5;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
}

.card-tag {
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 12px;
  border: 1px solid rgba(94, 123, 243, 0.3);
  background: linear-gradient(135deg, rgba(94, 123, 243, 0.1) 0%, rgba(16, 65, 181, 0.08) 100%);
  color: #1041B5;
  font-weight: 600;
  flex-shrink: 0;
  display: inline-block;
}

.card-title {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 13px;
  }
}

.card-specialty {
  font-size: 14px;
  color: #333;
  line-height: 1.7;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  
  @media (max-width: 768px) {
    font-size: 13px;
  }
}

// 响应式优化
@media (max-width: 768px) {
  .container {
    padding: 60px 16px 40px;
  }
  
  .recommend-section {
    margin-bottom: 48px;
    margin-left: 12px;
    margin-right: 12px;
  }
  
  .hot-section {
    margin-bottom: 32px;
    margin-left: 12px;
    margin-right: 12px;
  }
}
</style>
